module.exports = __webpack_public_path__ + "static/media/card-product2.4217a9b4.jpg";